module.exports = __webpack_public_path__ + "img/a2.f6dc73f2.jpg";